import {IDeviceInfo} from '@interfaces/devices';

export interface DeviceStorage {
    available: number;
    total: number;
}

interface DeviceStorageData {
    info?: IDeviceInfo;
    storage_available: number | null;
    storage_total: number | null;
}

export function getStorageFromDeviceInfo(info: IDeviceInfo): DeviceStorage {
    return {
        available: info.avail_int_mem + info.avail_sd_mem,
        total: info.total_int_mem + info.total_sd_mem,
    };
}

export function getDeviceStorage(device: DeviceStorageData): DeviceStorage | null {
    if (device.info) return getStorageFromDeviceInfo(device.info);

    if (device.storage_available && device.storage_total) {
        return {
            available: device.storage_available,
            total: device.storage_total,
        };
    }

    return null;
}
